var map = {
	"./v1.png": "11f1",
	"./v2.png": "8108",
	"./v3.png": "1223",
	"./v4.png": "a904",
	"./v5.png": "2297",
	"./v6.png": "2173",
	"./v7.png": "50e2",
	"./v8.png": "3445"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "caeb";